import type { CSSObject } from "type/tss";

export const styles = () => {
	return {
	} satisfies Record<string, CSSObject>;
};
